/**
 * Vanilla Next (vn) API
 *
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export const Operation = {
    APPLY_ALL: 'APPLY_ALL',
    APPLY_ALL_EXCEPT_EXIST: 'APPLY_ALL_EXCEPT_EXIST'
} as const;
export type Operation = typeof Operation[keyof typeof Operation];

